/** Helpers for rendering tag chips with their assigned colour.
 *  We accept either a tags array (from /api/tags) or a precomputed map.
 */

const DEFAULT_COLOR = "#f97316"; // brand orange

export function buildTagColorMap(tags = []) {
  const map = {};
  for (const t of tags) map[t.name] = t.color || DEFAULT_COLOR;
  return map;
}

/** Translate a hex colour into Tailwind-friendly inline styles for a chip:
 *  tinted background, deeper text. Falls back to default brand orange.
 */
export function tagChipStyle(color) {
  const hex = (color || DEFAULT_COLOR).replace("#", "");
  // pseudo-rgba background at 14% alpha
  return {
    backgroundColor: `#${hex}22`,
    color: `#${hex}`,
    borderColor: `#${hex}44`,
  };
}

/** Style for an *active* (selected) tag chip — solid coloured fill. */
export function tagChipActiveStyle(color) {
  return {
    backgroundColor: color || DEFAULT_COLOR,
    color: "#ffffff",
    borderColor: color || DEFAULT_COLOR,
  };
}
